import validator from "validator";
import type * as ValidatorTypes from "validator";

export const {
	blacklist,
	escape,
	isByteLength,
	isLuhnNumber,
	contains,
	equals,
	isAfter,
	isAlpha,
	isAlphanumeric,
	isAscii,
	isBase32,
	isBase58,
	isBase64,
	isBefore,
	isBoolean,
	isBtcAddress,
	isCreditCard,
	isCurrency,
	isDate,
	isDecimal,
	isDivisibleBy,
	isEAN,
	isEmail,
	isEmpty,
	isEthereumAddress,
	isFloat,
	isFullWidth,
	isHalfWidth,
	isHash,
	isHexColor,
	isHexadecimal,
	isIBAN,
	isIP,
	isISBN,
	isISIN,
	isISO8601,
	isISRC,
	isISSN,
	isIdentityCard,
	isJSON,
	isJWT,
	isLatLong,
	isLength,
	isLocale,
	isLowercase,
	isMACAddress,
	isMD5,
	isMagnetURI,
	isMimeType,
	isMobilePhone,
	isMongoId,
	isMultibyte,
	isNumeric,
	isOctal,
	isPassportNumber,
	isPort,
	isPostalCode,
	isRFC3339,
	isRgbColor,
	isSemVer,
	isSlug,
	isStrongPassword,
	isSurrogatePair,
	isTaxID,
	isURL,
	isUUID,
	isUppercase,
	isVAT,
	matches,
	normalizeEmail,
	rtrim,
	toBoolean,
	toDate,
	toFloat,
	toInt,
	trim,
	unescape,
	whitelist,
	isAbaRouting,
	isISO15924,
	isISO31661Alpha2,
	isISO31661Alpha3,
	isISO31661Numeric,
	isISO4217,
	isISO6346,
	isISO6391,
	isInt,
	isLicensePlate,
	isTime,
	isMailtoURI,
	stripLow,
	isVariableWidth,
	isBIC,
	isDataURI,
	isHSL,
	isULID,
	isFQDN,
	isIMEI,
	ltrim,
	isFreightContainerID,
	isIPRange,
	isIn,
	isWhitelisted
} = validator;

// re-export all types (DecimalLocale, MobilePhoneLocale, etc.)
export type { ValidatorTypes };
